// @ts-nocheck
import React from "react";

import { ENV, EXPLOID } from "common/constants/strings";
import { useExploApi } from "hooks";

function LocationLoyaltyReport() {
  const {
    LocationLoyaltyReport: { restaurantGroup, marketplace },
  } = EXPLOID;

  const { allLocations, userGroupToken, token } = useExploApi(
    restaurantGroup,
    marketplace,
  );
  if (!token) return null;

  return (
    <div>
      <explo-dashboard
        dash-user-group-token={userGroupToken}
        updateUrlParams
        isProduction={process.env.REACT_APP_ENV === ENV.PRODUCTION}
        environment={process.env.REACT_APP_ENV}
        locale-code="en-us"
        variables={JSON.stringify({
          included_locations: allLocations,
        })}
      />
    </div>
  );
}

export default LocationLoyaltyReport;
